import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';

@Injectable()
export class _OrganizationHolidayService{

  constructor(private http: HttpClient){ }

  getOrganizationHolidays(){
    return this.http.get(`${API_URL}/organization-holidays`);
  }

  createOrganizationHoliday(organizationHoliday){
    return this.http.post(`${API_URL}/organization-holidays`, [ organizationHoliday ]);
  }

  updateOrganizationHoliday(organizationHoliday){
    return this.http.put(`${API_URL}/organization-holidays`, [ organizationHoliday ]);
  }

  deleteOrganizationHoliday(organizationHolidayId){
    return this.http.delete(`${API_URL}/organization-holidays/` + organizationHolidayId);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/organization.holiday.service.ts